export const noop: VoidFunction = () => {};

export const isNoop = (fn: any): fn is VoidFunction => fn === noop;
